<template>
  <img alt="Data loading" v-show="props.loading" class="indicator" src="@/assets/img/snake_logo_animation_200.gif" />
</template>

<script setup lang="ts">
const props = defineProps<{
  loading: boolean;
}>();
</script>

<style scoped>
.indicator {
  position: fixed;
  right: 1.5em;
  margin-top: 1em;
  width: 5rem;
}
</style>
